import TabPage from "./../../factories/tab-page";
import GenericListTab from "./../../factories/generic-list-tab";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
import * as ko from "knockout";
import SummaryReportRoleTabDialog from "./../dialogs/summary-report-role-tab-dialog";
class SummaryReportRoleTab extends GenericListTab {
    Bao = Bao

    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
    }

    CustomFilter() {
        return null;
    }

    ItemCompleteCheck(item): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }

    Save(item): JQueryPromise<void> {
        let def = $.Deferred<void>();
        this.TabPage.IsLoading(true);
        Bao.post(this.UrlSave(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            model: item
        }), (response) => {

            if (response.Result === false) {
                this.TabPage.IsLoading(false);
                new BaoDialog(null, response.Message, "info");
            }
            else {
                this.Get().then(() => {
                    def.resolve();
                    this.TabPage.IsLoading(false);
                });
            }
        });
        return def.promise();
    }
}
export default SummaryReportRoleTab;